/* unplugin-vue-components disabled */import { render } from "./red_note_update_guide.vue?vue&type=template&id=0d388307&scoped=true"
import script from "./red_note_update_guide.vue?vue&type=script&lang=js"
export * from "./red_note_update_guide.vue?vue&type=script&lang=js"

import "./red_note_update_guide.vue?vue&type=style&index=0&id=0d388307&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d388307"]])

export default __exports__